
  function copyToClipboard(text, pageType, sectionId, partId) {
    navigator.clipboard.writeText(text).then(() => {
        const successElement = document.getElementById(`copy_success_${sectionId}_${partId}`);
        if (successElement) {
            successElement.style.display = 'flex';
            setTimeout(() => {
                successElement.style.display = 'none';
            }, 2000);
        }
    }).catch((err) => {
        console.error('复制失败:', err);
        alert('Copy failed, please select the text manually');
    });
  }

  async function clearCart() {
    try {
      const response = await fetch('/cart/clear.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
      });
      return await response.json();
    } catch (error) {
      console.error('Error clearing cart:', error);
      throw error;
    }
  }

  async function handleBundleAction(pageType, partId, clickType) {
    const buttonId = `${pageType}_${partId}_${clickType}`;
    const actionButton = document.getElementById(buttonId);
    const originalText = actionButton.textContent;
    actionButton.textContent = clickType === 'add' ? 'Adding...' : 'Processing...';
    actionButton.disabled = true;
    try {
      if (clickType === 'buy') {
        await clearCart();
      }
      const checkedBoxes = document.querySelectorAll(`.${pageType}-product-list.${partId} .custom-checkbox:checked`);
      if (checkedBoxes.length === 0) {
        alert('Please select at least one product');
        throw new Error('No items selected');
      }
      const itemsToAdd = Array.from(checkedBoxes).map((checkbox) => ({
        id: checkbox.value,
        quantity: 1,
        properties: {
          _bundle_type: clickType,
        },
      }));
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: itemsToAdd }),
      });
      const result = await response.json();
      if (result.items && result.items.length > 0) {
        if (clickType === 'add') {
          window.location.href = '/cart';
        } else {
          window.location.href = '/checkout';
        }
      } else {
        throw new Error('Failed to add items');
      }
    } catch (error) {
      console.error('Action failed:', error);
      actionButton.textContent = 'Error - Try Again';
    } finally {
      setTimeout(
        () => {
          actionButton.textContent = originalText;
          actionButton.disabled = false;
        },
        clickType === 'add' ? 2000 : 3000
      );
    }
  }

  function handleClickMore(e, pageType, partId, perPage, totalItems) {
    e.preventDefault();
    const blockItemsNum = document.querySelectorAll(`.${pageType}-product-list.${partId} .product-item-${partId}:not(.hidden)`).length;
    const hiddenItemsNum = totalItems - blockItemsNum;
    for (let index = 1; index <= perPage; index++) {
      const element = document.querySelector(`.${pageType}-product-list.${partId} .product-item-${partId}[data-item-index="${blockItemsNum + index}"]`);
      if (element) {
        element.classList.remove('hidden');
      }
    }
    if(hiddenItemsNum <= perPage) {
      e.currentTarget.classList.add('hidden');
    }
  }

  function handleClickTabsMore(e, pageType, partId, tabIndex, perPage, totalItems){
    e.preventDefault();
    const blockItemsNum = document.querySelectorAll(`.${pageType}-product-${partId}-tabs .${partId}-tab-${tabIndex} .product-item-${partId}:not(.hidden)`).length;
    const hiddenItemsNum = totalItems - blockItemsNum;
    for (let index = 1; index <= perPage; index++) {
      const element = document.querySelector(`.${pageType}-product-${partId}-tabs .${partId}-tab-${tabIndex} .product-item-${partId}[data-item-index="${blockItemsNum + index}"]`);
      if (element) {
        element.classList.remove('hidden');
      }
    }
    if(hiddenItemsNum <= perPage) {
      e.currentTarget.classList.add('hidden');
    }
  }